import { render, staticRenderFns } from "./resume_manage_detail.vue?vue&type=template&id=85df0ff0&scoped=true"
import script from "./resume_manage_detail.vue?vue&type=script&lang=js"
export * from "./resume_manage_detail.vue?vue&type=script&lang=js"
import style0 from "./resume_manage_detail.vue?vue&type=style&index=0&id=85df0ff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df0ff0",
  null
  
)

export default component.exports